module.exports = __webpack_public_path__ + "img/projects-5.d9dcc6c4.jpg";